import ExercisesTable from './ExercisesTable';

export default ExercisesTable;
